<script>
	import { createEventDispatcher } from 'svelte';
	import Icon from '@iconify/svelte';

	import { Drawer } from '@ongrid/chassis';

	const dispatch = createEventDispatcher();

	const onClose = () => {
		dispatch('close');
	};

	export let show = false;
	export let icon = null;
	export let title = null;
	export let width = 'w-[40rem]';
</script>

<Drawer bind:show {width} on:close={onClose}>
	<div class="w-full h-full text-white flex flex-col gap-0">
		<div class="flex gap-2.5 items-center px-4 py-6 h-16 text-primary-500 bg-pbg-700">
			<div class="flex justify-center items-center text-sm shrink-0 h-full">
				{#if $$slots.icon}
					<slot name="icon" />
				{:else}
					<Icon {icon} class="w-7 h-7 text-textpbg-700/50" />
				{/if}
			</div>

			{#if $$slots.title}
				<slot name="title" />
			{:else}
				<h1 class="font-normal text-xs lg:text-sm">{title}</h1>
			{/if}
		</div>

		<div class="overflow-y-auto h-full bg-pbg-500">
			<slot name="content" />
		</div>
	</div>
</Drawer>
